<template>
  <div class="user">
    <div class="user__avatar" aria-hidden="true">{{ getInitials }}</div>

    <div class="user__info">
      <div class="user__name" :title="getFullName">{{ getFullName }}</div>
      <div class="user__role">{{ getRole }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'User',
  computed: {
    ...mapGetters('user', ['getFullName', 'getInitials', 'getUserRole']),
    ...mapGetters('settings', ['getDefaultValues']),
    getRole () {
      return this.getDefaultValues?.role?.filter(el => el.code === this.getUserRole?.[0])[0]?.name
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
